import React, { Component } from 'react'
import { LeadersOverviewTable } from 'components/sections/leaders'
import { FilterLeadersOverview } from 'containers/filters'
import { apiConfiguration, apiLeadersOverview } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import { CONFIGURATION_KEYS } from '../../../constants/enums'

@meta({
  title: 'Leaders',
  intlKey: 'route.leaders'
})
@permissions()
@apiConfiguration({
  getValues: [
    CONFIGURATION_KEYS.enableContactLabels.id
  ]
})
@apiLeadersOverview({
  list: true,
  useCommonLimit: true
})
@tableCommon()
class LeadersOverview extends Component {
  render() {
    return (
      <div>
        <FilterLeadersOverview />
        <LeadersOverviewTable {...this.props} />
      </div>
    )
  }
}

export default LeadersOverview
